import { BaseCheckbox } from 'shared/ui/Checkbox';
import type { Option } from 'shared/ui/MultiSelect/interfaces';
import { getMenuBaseProps } from 'shared/ui/MultiSelect/Multiselect/utils';

import { ListOptionComponent } from './ListOption';
import { ListMenu } from './Menu';
import { SelectAll } from './SelectAll';

interface MenuBaseComponentProps<T extends Option> {
  open: boolean;
  options: T[];
  selectedOptions: T[];
  handleSelect: (option: T[], e?: React.MouseEvent<HTMLLIElement>) => void;
  handleSingleSelect: (option: T, e?: React.MouseEvent<HTMLLIElement>) => void;
  className?: string;
  isSelectAll?: boolean;
  withResize?: boolean;
  menuDefaultWidth?: number;
}

export function MenuBaseComponent<T extends Option>({
  options,
  open,
  selectedOptions,
  handleSelect,
  handleSingleSelect,
  className,
  withResize,
  isSelectAll = true,
  menuDefaultWidth,
}: MenuBaseComponentProps<T>) {
  return (
    <ListMenu
      open={open}
      className={className}
      withResize={withResize}
      menuDefaultWidth={menuDefaultWidth}
    >
      {isSelectAll && (
        <SelectAll
          handleSelect={handleSelect}
          selectedOptions={selectedOptions}
          options={options}
        />
      )}
      {options.map((option) => {
        const { key, selected } = getMenuBaseProps({ selectedOptions, option });

        return (
          <ListOptionComponent
            selected={selected}
            key={key}
            handleSelect={handleSingleSelect}
            option={option}
            className="py-[10px]"
            renderOption={(selected) => <BaseCheckbox isChecked={selected} />}
          />
        );
      })}
    </ListMenu>
  );
}
